import React, { FC, MouseEvent } from 'react';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

type NavbarNotificationButtonProps = {
  unreadCount: number;
  isActive: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

const NavbarNotificationButton: FC<NavbarNotificationButtonProps> = ({
  unreadCount,
  isActive,
  onClick,
}) => {
  const hasUnread = unreadCount > 0;

  return (
    <button
      type="button"
      className={`navbar__notification-btn${isActive ? ' navbar__notification-btn--active' : ''}${
        hasUnread ? ' navbar__notification-btn--unread' : ''
      }`}
      onClick={onClick}
      aria-label="Notifications"
    >
      <NotificationsOutlinedIcon className="navbar__notification-btn__icon" />
      {hasUnread && (
        <span className="navbar__notification-btn__badge">
          <span className="navbar__notification-btn__badge-count">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        </span>
      )}
    </button>
  );
};

export default NavbarNotificationButton;
